const VITE_API_URL = import.meta.env.VITE_API_URL;

export default {
  translations: `${VITE_API_URL}/endpoints/submissionApi/translations`,
  authRequest: `${VITE_API_URL}/endpoints/submissionApi/authRequest`,
  formTranslations: `${VITE_API_URL}/endpoints/submissionApi/formTranslations`,
  placeImages: `${VITE_API_URL}/endpoints/submissionApi/placeImages`,
  imageDelete: `${VITE_API_URL}/endpoints/submissionApi/deleteImage`,
  imageUpload: `${VITE_API_URL}/endpoints/submissionApi/uploadImage`,
  getImage: `${VITE_API_URL}/api/files/places`,
  autoSave: `${VITE_API_URL}/endpoints/submissionApi/autoSave`,
  submit: `${VITE_API_URL}/endpoints/submissionApi/submit`,
  selectOptions: `${VITE_API_URL}/endpoints/submissionApi/selectOptions`,
  submission: `${VITE_API_URL}/endpoints/submissionApi/submission`,
  publication: `${VITE_API_URL}/endpoints/submissionApi/publication`,
  place: `${VITE_API_URL}/endpoints/submissionApi/place`,
  revision: `${VITE_API_URL}/endpoints/submissionApi/revision`,
  translation: `${VITE_API_URL}/endpoints/submissionApi/translation`,
}